import CCUModal from './grid.ccu'

export default CCUModal